
// //slider custom swatch is-active
// function initProductCardSwatches(context = document) {
//   context.querySelectorAll(".card-wrapper").forEach((card) => {

//     if (card.dataset.swatchInit === "true") return;
//     card.dataset.swatchInit = "true";

//     const swatches = card.querySelectorAll(".color-swatch");
//     const productImage = card.querySelector(".card__media img");

//     if (!swatches.length || !productImage) return;

//     // Activate first swatch
//     swatches.forEach(s => s.classList.remove("is-active"));
//     swatches[0].classList.add("is-active");

//     swatches.forEach((swatch) => {
//       swatch.addEventListener("click", function () {
//         swatches.forEach(s => s.classList.remove("is-active"));
//         this.classList.add("is-active");

//         const newImage = this.dataset.image;
//         if (newImage) {
//           productImage.src = newImage;
//           productImage.srcset = newImage;
//         }
//       });
//     });
//   });
// }

// // Initial load
// document.addEventListener("DOMContentLoaded", () => {
//   initProductCardSwatches();
// });
// const observer = new MutationObserver((mutations) => {
//   mutations.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (node.nodeType === 1) {
//         if (node.matches(".card-wrapper") || node.querySelector(".card-wrapper")) {
//           initProductCardSwatches(node);
//         }
//       }
//     });
//   });
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

/********PRODUCT CARD SWATCH LOGIC********/
function initProductCardSwatches(context = document) {
  context.querySelectorAll(".card-wrapper").forEach((card) => {

    if (card.dataset.swatchInit === "true") return;
    card.dataset.swatchInit = "true";

    const swatches = card.querySelectorAll(".color-swatch");
    const productImage = card.querySelector(".card__media img");

    if (!swatches.length || !productImage) return;

    // Activate first swatch by default
    swatches.forEach(s => s.classList.remove("is-active"));
    swatches[0].classList.add("is-active");

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", function () {
        swatches.forEach(s => s.classList.remove("is-active"));
        this.classList.add("is-active");

        const newImage = this.dataset.image;
        if (newImage) {
          productImage.src = newImage;
          productImage.srcset = newImage;
        }
      });
    });
  });
}

/******FACET → SWATCH SYNC*********/
function getActiveFacetColors() {
  return Array.from(
    document.querySelectorAll(
      '.facets__label.facet-checkbox.active .facet-checkbox__text-label'
    )
  ).map(el => el.textContent.trim().toLowerCase());
}

function syncSwatchesWithFacets(context = document) {
  const activeColors = getActiveFacetColors();

  context.querySelectorAll(".card-wrapper").forEach(card => {
    const swatches = card.querySelectorAll(".color-swatch");
    const productImage = card.querySelector(".card__media img");
    if (!swatches.length || !productImage) return;

    let matchedSwatch = null;

    // Find first swatch that matches ANY active facet color
    swatches.forEach(swatch => {
      if (matchedSwatch) return;

      const swatchColor =
        (swatch.dataset.color || "").trim().toLowerCase();

      if (activeColors.includes(swatchColor)) {
        matchedSwatch = swatch;
      }
    });

    // Clear previous state
    swatches.forEach(s => s.classList.remove("is-active"));

    // Activate matched or fallback
    const target = matchedSwatch || swatches[0];
    target.classList.add("is-active");

    const img = target.dataset.image;
    if (img) {
      productImage.src = img;
      productImage.srcset = img;
    }
  });
}

/*******INITIAL LOAD********/
document.addEventListener("DOMContentLoaded", () => {
  initProductCardSwatches();
  syncSwatchesWithFacets();
});

/**FACET CHANGE LISTENER**************/
document.addEventListener("change", (e) => {
  if (
    e.target.matches(
      'input[name="filter.v.t.shopify.color-pattern"]'
    )
  ) {
    setTimeout(() => {
      initProductCardSwatches();
      syncSwatchesWithFacets();
    }, 50);
  }
});

/*******AJAX / DYNAMIC CONTENT OBSERVER***********/
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (
          node.matches(".card-wrapper") ||
          node.querySelector(".card-wrapper")
        ) {
          initProductCardSwatches(node);
          syncSwatchesWithFacets(node);
        }
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


//slideshow slider 
document.addEventListener('click', function (e) {
  const dot = e.target.closest('.slider-counter__link--dots');
  if (!dot) return;

  const sliderId = dot.getAttribute('aria-controls');
  const index = Number(dot.dataset.index);

  const slider = document.getElementById(sliderId);
  if (!slider) return;

  const slides = slider.querySelectorAll('.slider__slide');
  if (!slides[index]) return;

  const slide = slides[index];

  slider.scrollTo({
    left: slide.offsetLeft,
    behavior: 'smooth'
  });

  // Active state
  dot
    .closest('.slideshow__control-wrapper')
    .querySelectorAll('.slider-counter__link--dots')
    .forEach(d => d.classList.remove('is-active'));

  dot.classList.add('is-active');
});

// document.addEventListener('click', function (e) {
//   if (window.innerWidth < 990) return;

//   const summary = e.target.closest('#FacetFiltersForm .facets__summary');
//   if (!summary) return;

//   e.preventDefault();
// });
document.addEventListener('input', function(e) {
  if (!e.target.matches('.globo-form-input input[type="text"]')) return;

  const wrapper = e.target.closest('.globo-form-control');
  if (!wrapper) return;

  const labelEl = wrapper.querySelector('label[data-label]');
  if (!labelEl) return;

  const label = labelEl.dataset.label.trim();

  if (label === "Full Name" || label === "Name") {
    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
  }
});

// Custom JS for render the sticky ATC button on product page only for mobile

/**
 * mobile-product-bar.js
 * Handles two mobile product bar behaviours:
 *   1. DOM Element Relocator  – moves price & cart elements into #mobile-product-bar on mobile
 *   2. Button Dynamic Price   – injects a live price span inside the Add-to-Cart button on mobile
 */

document.addEventListener("DOMContentLoaded", function () {

 /* ─────────────────────────────────────────────
 * 1. DOM ELEMENT RELOCATOR
 * ───────────────────────────────────────────── */
(function initElementRelocator() {
  const priceEl        = document.querySelector(".price-with-payment-text");
  const cartEl         = document.querySelector(".quantity-add-to-cart-wrapper");
  const mobileContainer = document.getElementById("mobile-product-bar");

  if (!mobileContainer) return;

  const original = {
    priceParent : priceEl?.parentNode,
    cartParent  : cartEl?.parentNode,
    priceNext   : priceEl?.nextElementSibling,
    cartNext    : cartEl?.nextElementSibling,
  };

  function moveElements() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      if (priceEl && !mobileContainer.contains(priceEl)) {
        mobileContainer.appendChild(priceEl);
      }
      if (cartEl && !mobileContainer.contains(cartEl)) {
        mobileContainer.appendChild(cartEl);
      }

      // ✅ SHOW AFTER MOVING
      mobileContainer.classList.add("is-ready");

    } else {
      // Remove ready state
      mobileContainer.classList.remove("is-ready");

      // Restore price
      if (priceEl && original.priceParent) {
        original.priceNext
          ? original.priceParent.insertBefore(priceEl, original.priceNext)
          : original.priceParent.appendChild(priceEl);
      }

      // Restore cart
      if (cartEl && original.cartParent) {
        original.cartNext
          ? original.cartParent.insertBefore(cartEl, original.cartNext)
          : original.cartParent.appendChild(cartEl);
      }
    }
  }

  // Run after DOM is ready (important)
  window.addEventListener("load", moveElements);
  window.addEventListener("resize", moveElements);
})();


  /* ─────────────────────────────────────────────
   * 2. BUTTON DYNAMIC PRICE
   * ───────────────────────────────────────────── */
  (function initButtonDynamicPrice() {
    let priceInserted = false;
    let observer;

    function getCleanPrice(mainPrice) {
      const sale    = mainPrice.querySelector(".price-item--sale");
      const regular = mainPrice.querySelector(".price-item--regular");
      const priceHTML = (sale || regular)?.outerHTML || "";
      return priceHTML ? `<span class="dash">-</span>${priceHTML}` : "";
    }

    function initMobilePrice() {
      const isMobile      = window.innerWidth <= 768;
      const button        = document.querySelector('[id^="ProductSubmitButton"]');
      const buttonTextSpan = button?.querySelector("span");
      const mainPrice     = document.querySelector('[id^="price-"]');

      if (!button || !buttonTextSpan || !mainPrice) return;

      // Desktop → remove injected price if present
      if (!isMobile) {
        const existing = button.querySelector(".btn-dynamic-price");
        if (existing) existing.remove();
        if (observer) observer.disconnect();
        priceInserted = false;
        return;
      }

      // Prevent duplicate insert on subsequent resize calls
      if (priceInserted) return;

      // Create & insert price element
      const priceEl = document.createElement("span");
      priceEl.className = "btn-dynamic-price";
      priceEl.innerHTML = getCleanPrice(mainPrice);
      buttonTextSpan.insertAdjacentElement("afterend", priceEl);

      // Keep price in sync with variant changes
      function updatePrice() {
        priceEl.innerHTML = getCleanPrice(mainPrice);
      }

      document.addEventListener("variant:change", updatePrice);

      observer = new MutationObserver(updatePrice);
      observer.observe(mainPrice, { childList: true, subtree: true });

      priceInserted = true;
    }

    initMobilePrice();
    window.addEventListener("resize", initMobilePrice);
  })();

});

// Custom Dot code for product slider
/**
 * slider-dots.js
 * Drop this file into your Dawn theme: assets/slider-dots.js
 * Then include it in your theme.liquid just before </body>:
 * {{ 'slider-dots.js' | asset_url | script_tag }}
 */

(function () {
  // Wait until SliderComponent is defined by global.js
  customElements.whenDefined('slider-component').then(() => {
    const OriginalSliderComponent = customElements.get('slider-component');

    class SliderComponentWithDots extends OriginalSliderComponent {
      constructor() {
        super();
        this.dotsElement = this.querySelectorAll('.slider-counter__dot');
        this.initDots();
      }

      initDots() {
        this.dotsElement.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.slider.scrollTo({
              left: i * this.sliderItemOffset,
              behavior: 'smooth',
            });
          });
        });
      }

      update() {
        super.update();

        // Sync active dot to current page
        this.dotsElement.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.currentPage - 1);
        });
      }
    }

    // Only upgrade if not already redefined
    if (!customElements.get('slider-component-dots')) {
      // Patch existing instances already in the DOM
      document.querySelectorAll('slider-component').forEach((el) => {
        el.dotsElement = el.querySelectorAll('.slider-counter__dot');

        // Sync dots on scroll
        if (el.slider) {
          el.slider.addEventListener('scroll', () => {
            el.dotsElement.forEach((dot, i) => {
              dot.classList.toggle('is-active', i === el.currentPage - 1);
            });
          });
        }

        // Click to navigate
        el.dotsElement.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            el.slider.scrollTo({
              left: i * el.sliderItemOffset,
              behavior: 'smooth',
            });
          });
        });
      });
    }
  });
})();